<ng-template #categoryTooltip>{{ 'categories.' + item?.id | translate }}</ng-template>
<div
  *ngIf="mode === 'categories'"
  class="categories-item"
  [ngClass]="{ 'list-component': isListLayout }"
  [ngbTooltip]="categoryTooltip"
  [container]="tooltipContainer"
  [disableTooltip]="notOverflowed">
  {{ 'categories.' + item?.id | translate }}
</div>
<ng-template #countryTooltip>{{ ('countries.' + ((item?.id ?? 1) - 1) | translate).name }}</ng-template>
<div
  (click)="updateDecision(!$any(item).active, item?.id ?? 0)"
  [ngClass]="{'inactive': !$any(item).active && watchInactive, 'pointer': watchInactive, 'inactive-force': forceInactive}"
  class="img-wrapper"
  *ngIf="mode === 'countries'">
  <img
    class="countries me-1 mb-1"
    src="{{ 'assets/icons/flags/' + $any(item).code.toLowerCase() + '.png' }}"
    [ngbTooltip]="countryTooltip"
    tooltipClass="my-configurations-tooltip"
    placement="top-right"
    [container]="tooltipContainer" />
</div>
